module.exports = __webpack_public_path__ + "img/34-Wrinkles.8f7c65d2.png";